import styled from 'styled-components';

import { PrimaryButton } from 'brand-guidelines/Buttons-styled-components';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { FormCheckboxWrapper } from 'pages/checkout/components/common/input-styled-components';

export const PhoneNumberSubmitButton = styled(PrimaryButton)`
  align-self: stretch;
`;

export const AllowSmsCheckboxWrapper = styled(FormCheckboxWrapper)`
  text-wrap: initial;
`;

export const DisclaimerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const SmsHelpInfo = styled.span`
  display: flex;
  flex-direction: row;
  gap: 0.2em;

  font-size: 12px;
  line-height: 20px;
  color: ${BRAND_COLORS.black};

  ${TYPOGRAPHY.OPEN_SANS.base}
`;

export const Bolded = styled.span`
  ${TYPOGRAPHY.OPEN_SANS.bold}
`;
